import { withDependencies } from '@wix/thunderbolt-ioc'
import type { ServiceProvider } from '@wix/thunderbolt-symbols'
import type { StaticServiceDefinition } from '@wix/static-service'
import type { ServiceFactoryOpts } from '@wix/services-manager/types'
import type {
	ProvideComponentService,
	ProvideComponentConfig } from '@wix/services-manager-react/core-services/provide-component'
import {
	ProvideComponentServiceDefinition as definition,
	ProvideComponentServiceFactory as impl
} from '@wix/services-manager-react/core-services/provide-component'

export const provideComponentService = withDependencies(
	[],
	(): ServiceProvider<
		StaticServiceDefinition<ProvideComponentService, ProvideComponentConfig>,
		(opts: ServiceFactoryOpts<ProvideComponentConfig>) => ProvideComponentService
	> => {
		return {
			definition,
			impl,
			config: {},
		}
	}
)
